const en_msg = {
    placeholder: "Enter subject name or ID",
    searching: "Searching for matching companies",
    nothingFound: "No company found for the entered value.",
    startWritting: "Start typing",
    branch: "Branch",
    city: {
        name: "City:",
        placeholder: "Enter city"
    },
    country: {
        name: "Country:",
        placeholder: "Enter country"
    },
    international: {
        waiting: "Just a moment, we’re checking data from over 190 countries around the world",
        heading: "Going through",
        companies: "companies",
        managers: "managers",
        owners: "owners",
        shareholders: "shareholders",
        searching: "One sec please, we search in 110M entities from 190 countries.",
        downService: "Search is currently unavailable, please try again soon.",
        errors: {
            undefined: "Data is not available right now, try it later please",
            noCredit: "No credit left",
            noUser: "You are not logged in or in any organization",
            moodys: "Data is not available right now, try it later please",
            noCreditUsage: "You don't have permission to use credit",
            loginRequired: "You have to login in",
            creditFailure: "Change of credit state had failed, please contact our team"
        }
    },
    search: {
        advanced: "Advanced search",
    },
    leadForm: {
        name: "Name",
        phone: "Phone",
        email: "Email",
        send: "Contact me, please!",
        thankyou: "Thank you!",
        week: "We will get back to you today, explain everything, and, if needed, set it up right away.",
        weekend: "Enjoy the rest of your weekend! We will contact you on Monday, explain everything, and, if needed, set it up right away."
    },
    changeType: {
        cz: "You search Czech subjects only, for global screening go",
        global: "Do you want to search within Czech subjects only? Go",
        didntFound: "Didn’t found what you are looking for? Go global",
        here: "here"
    },
    organizationId: "IČO",
    types: {
        cz: "Czech subjects",
        global: "Global companies",
        person: "Global persons"
    },
    autoscreening: {
        filter: {
            placeholder: "Name of subject or IČO"
        },
        subject: "Company",
        organization_id: "IČO",
        state: "State",
        lastChange: "Last change",
        page: "Page {{ page }} of {{ maxPage }}"
    },
    person: {
        errors: {
            emptyName: "Name is empty.",
            notFullName: "Name is not in format <FirstName><Space><LastName>.",
            shortFirstName: "First name is short.",
            shortSecondName: "Last name is short.",
            emptyBirthdate: "Birthdate is empty.",
            emptyCountries: "No country is selected."
        },
        countriesHelp: "Enter all relevant countries. There may be several – for example, if the place of birth differs from permanent residence, or in case of a nationality change.",
        birthdateHelp: "If you only know the month and year, enter the first day of the month. If you only know the year, enter January 1st of that year. You can also leave the field empty – the result will be less accurate in that case.",
        nameHelp: "Full name of the person.",
        verify: "Screen",
        countries: "Countries *",
        birthdate: "Bidthdate",
        name: "Name *"
    },
    utils: {
        select: "Select",
        selected: "Selected",
        deselect: "Remove",
        more: "+ {count} more"
    }
}


export default en_msg;